import React from 'react'
import {compose } from 'recompose'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
//import _ from 'lodash'
import Button from '@material-ui/core/Button'


const styles = theme => ({
    paper: {
        padding: theme.spacing.unit,
      },
      rowContent: {
        marginBottom: '0.8em',
        padding: '0.2em',
        borderBottom: '2px solid #3f51b5',
        
    
    },
})



const CanidateDetails = (props) => {
    const { classes, canidate } = props
    
    const handleConnectAltCanidate = () => {
        const { handleAltCanidateConnect } = props
        handleAltCanidateConnect(canidate)
    }

    return (
        <Paper className={classes.paper}>
            <Typography variant="headline" color='primary' gutterBottom>
                Helfer Kontaktdaten
            </Typography>
            {canidate
                ?<div>
                    <Typography variant='subheading'>
                        <div  className={classes.rowContent}>{canidate.name}</div>
                        <div  className={classes.rowContent}>{canidate.strasse}</div>
                        <div  className={classes.rowContent}>{canidate.ort}</div>
                        <div  className={classes.rowContent}>{canidate.email}</div>
                        <div  className={classes.rowContent}>{canidate.telefon}</div>
                    </Typography>
                    <div>
                        <Button
                            variant='contained'
                            color='primary'
                            size='small'
                            onClick={()=>handleConnectAltCanidate(canidate)}
                        >
                            Helfer vermitteln
                        </Button>
                    </div>
                    
                </div>
                : <div  className={classes.rowContent}>Loding.....</div>
            }
        </Paper>)
}




export default compose(
    withStyles(styles)
)(CanidateDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminConnectedEvents/AdminConnectedEventsDetails/AltCanidateDetails.js